import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Component, Inject, ViewChild} from '@angular/core';
import {EmailVerificationFormComponent} from '../email-verification-form/email-verification-form.component';
import {Logger} from '../utils/Logger';
import {Toaster, Type} from '../toaster/Toaster';

export interface EmailDialogConfig {
    title: string;
}

@Component({
    selector: 'app-email-verification-modal-component',
    templateUrl: './email-verification-modal.component.html',
    styleUrls: ['email-verification-modal.css']
})
export class EmailVerificationModalComponent {
    @ViewChild(EmailVerificationFormComponent)
    emailVerificationForm: EmailVerificationFormComponent;

    constructor(private dialogRef: MatDialogRef<EmailVerificationModalComponent>,
                @Inject(MAT_DIALOG_DATA) public config: EmailDialogConfig) {
    }

    public async updateEmailid(): Promise<void> {
        try {
            await this.emailVerificationForm.registerEmail();
            Toaster.toast(`Your email address has been updated successfully.`, Type.Success);
            this.dialogRef.close('successful');
        } catch (error) {
            Logger.error(`An error occurred while associating email address with user. ${error}`);
        }
    }

    public showActionButton(): boolean {
        return this.emailVerificationForm && !!this.emailVerificationForm.emailVerificationRequested;
    }
}
